import React from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon } from 'lucide-react';
export function WarningBox() {
  return <section className="w-full py-12 px-6 md:px-12 relative z-20" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-58">
        <div className="relative overflow-hidden rounded-2xl bg-carbon-900 border border-orange-900/50 p-6 md:p-8" data-id="element-59">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-500/50 to-red-600/50" data-id="element-60" />

          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-61">
            <div className="p-3 rounded-xl bg-orange-950/30 border border-orange-900/30 shrink-0" data-id="element-62">
              <AlertOctagon className="w-6 h-6 text-orange-500/80" data-id="element-63" />
            </div>

            <div className="flex flex-col gap-4" data-id="element-64">
              <p className="text-gray-300 leading-relaxed" data-id="element-65">
                <strong className="text-orange-200/90 font-medium" data-id="element-66">
                  Importante:
                </strong>{' '}
                Si no seguís los pasos del video en orden, puede que no podamos
                activar correctamente tu acceso al copy trading.
              </p>

              <div className="h-px w-full bg-carbon-800" data-id="element-67" />

              <p className="text-sm text-gray-500 leading-relaxed" data-id="element-68">
                El copy trading implica riesgo. No hay resultados garantizados.
                Operá siempre con capital que puedas permitirte arriesgar.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}